module.exports = __webpack_public_path__ + "static/media/amazon.5ba93fca.png";